import LoginBaseView from './loginBaseView.js';
import loginFormTemplate from '../../../templates/login/loginFormTemplate.html';

/*
 * Login Form View
 * #login
 * TB
 */

const LoginFormView = LoginBaseView.extend({
  className: 'container',
  templateDefault: _.template(loginFormTemplate),
  loginDurationCookie: storageUtils.getCookieOrLocalStorageItem('s_loginDuration'),
  loginMessage: storageUtils.getCookieOrLocalStorageItem('s_loginMessage'),
  currentTooltipSuggestion: '',
  currentTooltip: null,
  gravatarAjax: null,
  currentEmail: null,
  currentGravatarImage: null,
  gravatarCache: null,
  form: null,
  currentGravatarCall: null,

  events: {
    'keyup form': 'generalisedKeyListener',
    'click #login-submit': 'submitLoginForm',
    'keypress input#login-Submit': 'enterKeyFilter',
    'click .login-checkbox input': 'checkBoxToggle',
    'click .close-iframe': 'closeIframe',

    'keyup input#login-inputPassword': 'validateSubmit',
    'keyup #login-inputEmail': 'validateSubmit',
    'change input#login-inputPassword': 'validateSubmit',
    'change #login-inputEmai': 'validateSubmit',
    'click .openSignupTab': 'openSignupTab',
  },

  initialize(options) {
    _.extend(this, options);
    const $body = $('body');
    const that = this;

    if (!this.hasOwnProperty('message')) this.message = { message: { type: null, value: null } };

    if ($body.hasClass('concise')) {
      this.message.isConcise = true;
    }
    // render form
    this.$el.html(this.templateDefault(this.message));
    $body.html(this.$el);

    // this setTimeout fixes bug
    // #411 The login page has broken layout for several seconds
    setTimeout(() => {
      that.$('.content').fadeIn();
    }, 1000);

    // setup scoped element variables
    this.$form = this.$el.find('#loginForm:eq(0)');
    // this.$inputText = this.$el.find("input[type=email]");
    this.$inputText = this.$el.find('#login-inputEmail');
    this.$inputPassword = this.$el.find('input[type=password]');
    this.$inputCheckbox = this.$el.find('input[type=checkbox]');
    this.$inputSubmit = this.$el.find('input[type=submit]');
    this.$errorMessages = this.$el.find('.error-messages');
    this.$avatar = this.$el.find('.login-avatar');

    // initialise validator
    this.form = validator.initialize(this.$form, {}, {}, _.bind(function (errors) {
      const $element = $('<div>');

      // loop error and build error message
      _.each(errors, (error) => {
        $element.append(`<p>${$(error).text()}</p>`);
      });

      // append to the correct element
      this.$errorMessages.html($element);
    }, this), true);

    // by default disable login until valid
    if (!this.form.checkForm()) this.$inputSubmit.prop('disabled', true);

    // if login duration cookie set then tick box
    if (this.loginDurationCookie) this.$inputCheckbox.prop('checked', true);

    if (this.loginMessage !== null) {
      this.$errorMessages.append(`<div class="alert alert-error ">${this.loginMessage}</div>`);
      advancedLocalStorage.removeItem('s_loginMessage');
    }

    // focus on either email or password field
    this.$inputText.focus();

    // if form email cookie set then setup the form accordingly
    if (storageUtils.getCookieOrLocalStorageItem('s_loginForm_emailFieldSet')) {
      this.$inputText.val(storageUtils.getCookieOrLocalStorageItem('s_loginForm_emailFieldSet'));
      this.$inputPassword.focus();
      advancedLocalStorage.removeItem('s_loginForm_emailFieldSet');
    }

    // set default avatar
    this.$avatar.find('img').attr({ src: window.appConfig.branding.logo_url });

    // initialise mailcheck
    this.mailcheck();

    setTimeout(_.bind(function () {
      this.validateSubmit();
    }, this), 1000);
  },

  render() {

  },

  generalisedKeyListener(event) {
    const emailValid = this.$form.validate().element(this.$inputText);

    if (window.appConfig.isWhiteLabel) {
      return;
    }

    // if key is escape is password and tooltip is open then close it
    if ((event.keyCode === 27 || this.$inputPassword.is(':focus')) && event.keyCode !== 9 && this.currentTooltip !== null) {
      this.currentTooltip.tooltip('destroy');
    }

    if ((this.$inputText.is(':focus') && emailValid) || (this.$inputPassword.is(':focus') && event.keyCode === 9 && emailValid)) {
      advancedLocalStorage.setItem('s_loginForm_passwordReset', this.$inputText.val(), 1);
    }
  },

  enterKeyFilter(event) {
    // filter enter key
    if (event.keyCode != 13) return;
    this.submitLoginForm(event);
  },

  validateSubmit() {
    if (this.form.checkForm()) {
      this.$inputSubmit.prop('disabled', false);
      this.$errorMessages.html('<p></p>');
    } else {
      this.$inputSubmit.prop('disabled', true);
    }
  },

  openSignupTab(e) {
    e.preventDefault();
    parent.postMessage('openSignupTab', '*');
  },

  submitLoginForm(event) {
    event.preventDefault();

    // if validates then redirect window
    if (validator.isValid()) {
      // feedback on login button and disable
      this.$inputSubmit.button('loading');
      // if the "remember me" field is checked then set a cookie (resetting the expiry date if already set)
      if (this.$inputCheckbox.is(':checked')) advancedLocalStorage.setItem('s_loginDuration', '14', 14);
      // set the email address field value to a cookie
      advancedLocalStorage.setItem('s_loginForm_emailFieldSet', this.$inputText.val(), 14);
      // cleanup other cookies
      advancedLocalStorage.removeItem('s_loginForm_passwordReset');

      advancedLocalStorage.setItem('s_clearCacheOnLogin', 'true', 1);

      Sendible.Connect.loginMethod(
        window.appConfig.applicationId,
        {
          username: this.$inputText.val(),
          api_key: this.$inputPassword.val(),
          source: 'no_redirect',
        },
        _.bind(this.handleAPISuccess, this),
        _.bind(this.handleAPIError, this),
      );
    }
  },

  handleAPISuccess(result) {
    if (typeof result.error !== 'undefined') {
      this.handleAPIError(result.error);
      return;
    }

    sessionStorage.setItem(window.appConfig.LOGIN_AUTH_TOKEN, result.access_token);

    window.location.reload();
  },

  handleAPIError(result) {
    if (typeof result.error !== 'undefined') {
      this.handleErrors(result.error);
    }
  },

  handleErrors(error) {
    this.$('.alert-error').remove();

    if (error.type === 'username_password_incorrect') {
      this.$errorMessages.append(`<div class="alert alert-error ">${error.message}</div>`);
    }

    if (this.form.checkForm()) {
      this.$inputSubmit.prop('disabled', false);
      this.$inputSubmit.removeClass('disabled');
      this.$inputSubmit.val(this.$inputSubmit.data('text'));
    }
  },

  checkBoxToggle() {
    // if the "remember me" field is checked then set a cookie to indicate the login duration should be 14 days
    if (this.$inputCheckbox.is(':checked')) {
      advancedLocalStorage.setItem('s_loginDuration', '14', 14);
    }

    // if the "remember me" field is un-checked and the "loginDuration" cookie is set then remove the cookie
    if (this.$inputCheckbox.is(':not(:checked)') && storageUtils.getCookieOrLocalStorageItem('s_loginDuration')) {
      advancedLocalStorage.removeItem('s_loginDuration');
    }
  },

  closeIframe() {
    parent.postMessage('_closeIframe', '*');

    if (this.message.isConcise) {
      window.close();
    }
  },

  cleanup() {
    this.unbind();
    this.remove();
  },

});

export default LoginFormView;
